import { render, staticRenderFns } from "./CatalogsMaintenance.vue?vue&type=template&id=7f18ed7a&"
import script from "./CatalogsMaintenance.vue?vue&type=script&lang=js&"
export * from "./CatalogsMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./CatalogsMaintenance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f18ed7a')) {
      api.createRecord('7f18ed7a', component.options)
    } else {
      api.reload('7f18ed7a', component.options)
    }
    module.hot.accept("./CatalogsMaintenance.vue?vue&type=template&id=7f18ed7a&", function () {
      api.rerender('7f18ed7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/materialsRequests/components/CatalogsMaintenance.vue"
export default component.exports